import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { useTheme } from '@mui/material';

export const Support = ({ size = 'large' }) => {
  const theme = useTheme();

  return (
    <VolunteerActivismIcon
      fontSize={size}
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
